import rules from "./toelatings";

const kryBittoelatingsUitBlok = (bittoelatings, bittoelatingsblok) => {
    return bittoelatings[
        `bittoelatings_${String.fromCharCode(
            "a".charCodeAt(0) + parseInt(bittoelatingsblok, 10)
        )}`
    ];
};

const kryToelatingItems = permissionsneeded => {
    let masks = [];
    for (let i = 0; i < Object.keys(permissionsneeded).length; i++) {
        var result = rules.find(obj => obj.rule === permissionsneeded[i]);
        if (result) {
            masks.push(result);
        }
    }
    return masks;
};

const check = (permissionsowned, anyPermissions, requiredPermissions) => {
    if (!requiredPermissions && !anyPermissions) {
        return true;
    }
    if (requiredPermissions && requiredPermissions.length > 0) {
        let allowed = true;
        let bitmasks = kryToelatingItems(requiredPermissions);
        if (bitmasks.length < 1) {
            return false;
        }
        for (let i = 0; i < bitmasks.length; i++) {
            if (bitmasks[i]) {
                let bitmaskresult = kryBittoelatingsUitBlok(permissionsowned, bitmasks[i].blok);
                if (parseInt(bitmasks[i].bitmask, 10) !== (bitmaskresult & parseInt(bitmasks[i].bitmask, 10))) {
                    allowed = false;
                }
                // console.log(
                //     bitmaskresult,
                //     bitmasks[i].bitmask,
                //     parseInt(bitmasks[i].bitmask, 10) ===
                //     (bitmaskresult & parseInt(bitmasks[i].bitmask, 10))
                // );
            } else {
                allowed = false;
            }
        }
        return allowed;
    } else {
        let allowed = false;
        let bitmasks = kryToelatingItems(anyPermissions);
        for (let i = 0; i < bitmasks.length; i++) {
            let bitmaskresult = kryBittoelatingsUitBlok(
                permissionsowned,
                bitmasks[i].blok
            );
            // console.log(
            //     bitmaskresult,
            //     bitmasks[i].bitmask,
            //     parseInt(bitmasks[i].bitmask, 10) ===
            //     (bitmaskresult & parseInt(bitmasks[i].bitmask, 10))
            // );
            if (
                parseInt(bitmasks[i].bitmask, 10) ===
                (bitmaskresult & parseInt(bitmasks[i].bitmask, 10))
            ) {
                allowed = true;
            }
        }
        return allowed;
    }
};

const AccessControl = ({
    permissionsowned,
    anyPermissions,
    requiredPermissions,
    children = null,
    renderNoAccess = () => null
}) =>
    check(permissionsowned, anyPermissions, requiredPermissions)
        ? children
        : renderNoAccess();

export default AccessControl;
